import { useQSet } from '@exam-management/common/qset-provider';
import { QSetDeletionModal } from '@exam-management/qset-deletion';
import { QSetDuplicationModal } from '@exam-management/qset-duplication';
import { QSetExportFormModal } from '@exam-management/qset-export';
import type { PropsWithChildren } from '@shared/utils';
import { createContext, useMemo, useState } from 'react';

import { QSetDetailsHeaderModalAction, type QSetDetailsHeaderModalContextData } from './types';

export const QSetDetailsHeaderModalContext = createContext<
  QSetDetailsHeaderModalContextData | undefined
>(undefined);

type QSetDetailsHeaderModalProviderProps = PropsWithChildren;

export default function QSetDetailsHeaderModalProvider(
  props: Readonly<QSetDetailsHeaderModalProviderProps>,
) {
  const { children } = props;
  const [action, setAction] = useState<QSetDetailsHeaderModalAction | null>(null);
  const { qSet } = useQSet();
  const { id: qSetId } = qSet;

  const handleSetAction = (action: QSetDetailsHeaderModalAction | null) => {
    setAction(action);
  };

  const handleClose = () => {
    setAction(null);
  };

  const contextValue = useMemo(() => {
    return {
      setAction: handleSetAction,
    };
  }, []);

  return (
    <QSetDetailsHeaderModalContext.Provider value={contextValue}>
      {children}
      <QSetDuplicationModal
        qSetId={qSetId}
        open={action === QSetDetailsHeaderModalAction.DUPLICATE}
        onClose={handleClose}
      />
      <QSetExportFormModal
        qSetId={qSetId}
        open={action === QSetDetailsHeaderModalAction.EXPORT}
        onClose={handleClose}
      />
      <QSetDeletionModal
        qSetId={qSetId}
        open={action === QSetDetailsHeaderModalAction.DELETE}
        onClose={handleClose}
      />
    </QSetDetailsHeaderModalContext.Provider>
  );
}
